export default {
  title: 'Relatório da equipa de vendas',
  fields: {
    name: 'Nome',
    area: 'Área',
    signed: 'Assinado',
    live: 'Ativo',
  },
  buttons: {
    download_report: 'Descarregar relatório',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados, atualize a página',
  },
};
